import React, { FC } from 'react';
import styles from '../SiteReadyStep.scss';
import { useAppStore } from 'stores/state';
import { templateUtils } from 'utils/templates';
import { templates } from 'config/templates';
import { MobileDevice } from 'components/MobileDevice/MobileDevice';
import { Button } from '@wix/design-system';
import { ActionId, StepId } from 'config/flow';
import { biEvents } from 'api/bi-events';
import { BI_STEP_NAME } from 'config/bi-events';
import { useOrchestratorNavigation } from '@wix/gg-common-lib/orchestrator';
import { Trans, useTranslation } from '@wix/wix-i18n-config';
import { ArrowRight, MobileSmall } from '@wix/wix-ui-icons-common';
import { TextDivider } from 'components/TextDivider/TextDivider';
import { redirects } from 'api/redirects';

export const SiteReadyStepMobile: FC = () => {
  const { t } = useTranslation();
  const { navigate } = useOrchestratorNavigation();

  const templateSlug = useAppStore((state) => state.templateSlug);
  const template = templateSlug ? templates[templateSlug] : undefined;
  const mobileImageSrc = template ? templateUtils.getAssetUrl(template.assets.mobile) : undefined;

  const handleUpgradeNow = () => {
    biEvents.actionClicked({
      screenName: BI_STEP_NAME[StepId.SiteReady],
      button_name: 'upgrade-now',
    });
    navigate(ActionId.RedirectToUpgradePlan);
  };

  const handleOpenMobileApp = () => {
    biEvents.actionClicked({
      screenName: BI_STEP_NAME[StepId.SiteReady],
      button_name: 'mobile-app',
    });
    redirects.redirectToMobileApp();
  };

  return (
    <div className={styles.siteReadyStepMobile}>
      <div className={styles.siteReadyStepMobileContentTypography}>
        <p className={styles.siteReadyStepMobileContentTitle}>
          <Trans i18nKey="site-ready-step.content.title" components={{ br: <br /> }} />
        </p>
        <p className={styles.siteReadyStepMobileContentDescription}>
          <Trans i18nKey="site-ready-step.content.description" components={{ br: <br /> }} />
        </p>
      </div>
      <Button size="large" skin="premium" onClick={handleUpgradeNow} suffixIcon={<ArrowRight />}>
        {t('site-ready-step.content.button.upgrade-now')}
      </Button>
      <TextDivider text={t('site-ready-step.mobile-content.buttons-divider')} />
      <Button skin="dark" priority="secondary" prefixIcon={<MobileSmall />} onClick={handleOpenMobileApp}>
        {t('site-ready-step.mobile-content.button.open-app')}
      </Button>
      {mobileImageSrc && (
        <div className={styles.siteReadyStepMobilePreview}>
          <MobileDevice>
            <img src={mobileImageSrc} alt="Mobile preview" />
          </MobileDevice>
        </div>
      )}
    </div>
  );
};
